import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'app/loader.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
  constructor(
    private loaderService: LoaderService
  ) { }

  ngOnInit() {
    this.loaderService.setLoaded();
  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/page-not-found/page-not-found.component.ts